<template>
	<fieldset :class="$style.fields">
		<legend :class="$style.legend">Email settings</legend>
		<label :class="$style.label" for="lang">Language</label>
		<select
			id="lang"
			:value="language"
			name="lang"
			:class="$style.field"
			@change="loadLanguage($event.target.value)"
		>
			<option
				v-for="(value, key) in iso"
				:key="key"
				:selected="value === 'English'"
				:value="key"
			>
				{{ value }}
			</option>
		</select>
		<label :class="$style.label" for="subject">Subject line</label>
		<input
			id="subject"
			:value="subject"
			type="text"
			:class="$style.field"
			@input="loadSubject($event.target.value)"
		/>
		<label :class="$style.label" for="title">Preheader text</label>
		<input
			id="title"
			:value="title"
			type="text"
			:class="$style.field"
			@input="loadTitle($event.target.value)"
		/>
	</fieldset>
</template>

<script>
import iso from '@/assets/iso'
import emailSettings from '@/store/emailSettings'
import { computed } from '@vue/composition-api'

export default {
	name: 'Settings',
	setup() {
		const {
			getLanguage,
			getSubject,
			getTitle,
			loadLanguage,
			loadSubject,
			loadTitle,
		} = emailSettings

		return {
			iso,
			language: computed(() => getLanguage.value),
			loadLanguage,
			loadSubject,
			loadTitle,
			subject: computed(() => getSubject.value),
			title: computed(() => getTitle.value),
		}
	},
}
</script>

<style lang="less" module>
.fields {
	border: 0;
	contain: content;
	display: flex;
	flex-flow: column;
	font-size: 1.4rem;
	padding: 0 #theme.spacing[l];
	margin: 0 0 #theme.spacing[xl];
}

.field {
	border: 0;
	border-radius: 0;
	font-family: #theme.typography[base];
	font-size: 1.7rem;
	line-height: 2.4rem;
	padding: 0.8rem;
	width: inherit;
	width: -webkit-fill-available;
}

.label {
	font-weight: 600;
	padding: #theme.spacing[l] 0 #theme.spacing[s];
}

.legend {
	height: 0;
	visibility: hidden;
}
</style>
